export default __webpack_public_path__ + "static/media/event-image-big.8717f3df.jpg";